import { useEffect } from 'react';
import { DatarouterError } from '@zg-rentals/web-base';
import { useToast } from '@zillow/constellation-10';

import UnmaskedToast from '../components/UnmaskedToast';

export const useErrorHandler = ({ isError, error }: { isError: boolean; error: unknown }) => {
  const { enqueueToast } = useToast();

  useEffect(() => {
    if (isError) {
      enqueueToast(<UnmaskedToast tone="critical">{DatarouterError.getDisplayMessage(error)}</UnmaskedToast>);
    }
  }, [isError, enqueueToast, error]);
};
